import CredReqEventStatus from '$shared/constants/CredReqEventStatus';
import { Extension } from '../Extension';

export class CredReqEventStatusExtension extends Extension<CredReqEventStatus> {
  public get label(): string {
    switch (this.value) {
      case CredReqEventStatus.RequestSubmitted:
        return 'Request Submitted';
      case CredReqEventStatus.RequestInProgress:
        return 'In Progress';
      case CredReqEventStatus.AdditionalInformationRequested:
        return 'Additional Info Needed (1st attempt)';
      case CredReqEventStatus.SecondAttemptMissingInfo:
        return 'Additional Info Needed (2nd attempt)';
      case CredReqEventStatus.ThirdAttemptMissingInfo:
        return 'Additional Info Needed (3rd attempt)';
      case CredReqEventStatus.AdditionalInformationSubmitted:
        return 'Additional Information Submitted';
      case CredReqEventStatus.Completed:
        return 'Completed';
      case CredReqEventStatus.CompletedWithConcern:
        return 'Completed - Concern';
      case CredReqEventStatus.UnableToComplete:
        return 'Unable to Complete';
      case CredReqEventStatus.CancellationRequested:
        return 'Cancellation Requested';
      case CredReqEventStatus.Cancelled:
        return 'Cancelled';
      default:
        return this.value;
    }
  }

  static get(nav: CredReqEventStatus): CredReqEventStatusExtension {
    return new CredReqEventStatusExtension(nav);
  }

  static getAsList(ignoreItems?: CredReqEventStatus[]): CommonList[] {
    return Object.values(CredReqEventStatus)
      .filter((status) => !ignoreItems?.includes(status))
      .map((nav) => CredReqEventStatusExtension.get(nav).toList());
  }

  static getFinalCompleteStatusList(): CredReqEventStatus[] {
    return [
      CredReqEventStatus.Cancelled,
      CredReqEventStatus.Completed,
      CredReqEventStatus.CompletedWithConcern,
      CredReqEventStatus.UnableToComplete
    ];
  }

  static getAdditionalInfoRequestedStatusList(): CredReqEventStatus[] {
    return [
      CredReqEventStatus.AdditionalInformationRequested,
      CredReqEventStatus.SecondAttemptMissingInfo,
      CredReqEventStatus.ThirdAttemptMissingInfo
    ];
  }

  static getNotesSupportedStatusList(): CredReqEventStatus[] {
    return [
      ...this.getAdditionalInfoRequestedStatusList(),
      CredReqEventStatus.AdditionalInformationSubmitted,
      CredReqEventStatus.CompletedWithConcern,
      CredReqEventStatus.Cancelled,
      CredReqEventStatus.UnableToComplete,
      CredReqEventStatus.Completed
    ];
  }

  static getCompletedCvoStatusList(): CredReqEventStatus[] {
    return [CredReqEventStatus.Completed, CredReqEventStatus.CompletedWithConcern];
  }
}
